import { primaryColor, fontColor, webFont, textBlack } from '../../config/theme';

const style = {
	centerGrid: {
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center'
	},
	getStarted: {
		textDecoration: 'none',
		color: fontColor,
		backgroundColor: primaryColor,
		borderRadius: '40px',
		fontFamily: webFont,
		padding: '12.5px 30px',
		fontWeight: 500,
		fontSize: '24px',
		textTransform: 'none',
		minWidth: 240,
		fontSize: 18,
	},
	specialDiv: {
		backgroundColor: '#f7f7f7',
		padding: '50px 0px',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		fontFamily: webFont,
		color: textBlack
	},
	subscribeBtn: {
		color: fontColor,
		padding: "10px 20px",
		borderRadius: "0px",
		fontFamily: webFont,
		textTransform: "capitalize",
		position: "relative",
		left: "-2px",
		top: "1px",
		fontWeight: 'normal',
		fontSize: 18,
		boxShadow: 'none'
	},
	subscribeField: {
		marginTop: '2px',
		borderColor: 'rgba(0, 0, 0, 0.23)',
		borderStyle: 'solid',
		borderWidth: '1px',
		padding: '8px 10px',
		fontFamily: webFont
	},
	error: {
		color: 'red'
	},
	setColor: {
		color: primaryColor
	},
	msg: {
		fontWeight: 500,
		color: textBlack,
		textTransform: 'none',
		fontFamily: webFont,
	},
	setFont: {
		fontFamily: webFont
	},
};

export default style;
